import { iconA11y, type IconProps } from './iconProps';

/**
 * Outbound / external-link glyph from Figma component `219:165527`.
 * Uses `currentColor` so it inherits the surrounding link text colour.
 */
export function ExternalLinkIcon({ size = 16, title, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      {...iconA11y(title)}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12.6667 8.66634V13.9997H2V3.33301H7.33333" stroke="currentColor" />
      <path
        d="M8.69491 1.99967H14.0013V7.30607M14.0013 1.99967L8.66797 7.33301"
        stroke="currentColor"
      />
    </svg>
  );
}
